import RichTextHeadline from 'components/shared/RichTextHeadline/RichTextHeadline';
import { cn, getColorway } from 'utils/styles';
import { FaqClassNames, FaqProps } from 'libs/contentful/props';
import Schema from 'components/shared/Schema/Schema';
import { getRichTextValue, getColorwayName } from 'utils/formatters';
import ToggleMenu from './ToggleMenu';
import { liveUpdateAttrs } from 'libs/contentful/utils';

export const Faq = ({ sys, variant, sectionName, color, headline, toggleItems }: FaqProps) => {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: toggleItems.items.map(toggleItem =>
      toggleItem.contentCollection.items.map(accordionItem => ({
        '@type': 'Question',
        name: accordionItem.accordionLabelRte ? getRichTextValue(accordionItem.accordionLabelRte) : '',
        acceptedAnswer: {
          '@type': 'Answer',
          text: accordionItem.accordionCopy ? getRichTextValue(accordionItem.accordionCopy) : '',
        },
      })),
    ),
  };

  const internalClassNames: FaqClassNames = {
    outerWrapper: cn('all-margins', getColorway(color)),
    innerWrapper: cn('content-wrapper'),
    headline: cn('font-sans font-semibold text-heading-md md:text-heading-lg'),
  };

  return (
    <section
      {...(sectionName != null && { id: encodeURIComponent(sectionName) })}
      className={internalClassNames.outerWrapper}>
      {jsonLd && <Schema jsonLd={jsonLd} />}
      <div className={internalClassNames.innerWrapper}>
        {headline && (
          <div className={internalClassNames?.headline} {...liveUpdateAttrs(sys?.id, 'headline')}>
            <RichTextHeadline headline={headline} />
          </div>
        )}
        <ToggleMenu toggleItems={toggleItems.items} sys={sys} color={getColorwayName(color)} variant={variant} />
      </div>
    </section>
  );
};

export default Faq;
